import moment from "moment";
import commonFn from "@/commons/commonFunction";

export default {
  resetState(state) {
    let x = 1;
    //Object.assign(state, defaultConfigState);
  },
  updateConfig: function(state, payload) {
    let currentDate = moment(payload.CurrentDate).toDate();
    state.ConfigInfo = {
      ...state.ConfigInfo,
      ...payload,
      CurrentDate: currentDate,
      CurrentDateText: moment(currentDate).format("YYYY-MM-DD HH:mm:ss")
    };
  },
  updateOrganizationUnit: function(state, payload) {
    let org = {},
      fields = [
        "OrganizationUnitID",
        "OrganizationUnitName",
      ];
    fields.forEach(i => {
      org[i] = payload[i];
    });

    //org
    state.OrganizationUnit = org;
    commonFn.setLocalStorage('OrganizationUnit', JSON.stringify(org));

    //update context
    state.Context.OrganizationUnitID = payload.OrganizationUnitID;
    commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
  },
  updateCulture: function(state, payload) {
    state.Context.Culture = payload;
  },
  updateToken(state, payload) {
    // debugger;
    state.TokenTimeout = new Date().addSeconds(payload.expiredSecond).getTime();
    state.Token = payload.token;
    state.RefreshToken = payload.refreshToken;
    state.UserId = payload.userId;
    state.Role = payload.role;
    state.UserName = payload.userName;
    state.Permissions = payload.permissions;

    //ghi context vào localstorage
    commonFn.setLocalStorage("TokenTimeout", state.TokenTimeout);
    commonFn.setLocalStorage("Token", state.Token);
    commonFn.setLocalStorage("RefreshToken", state.RefreshToken);
    commonFn.setLocalStorage("UserId", state.UserId);
    commonFn.setLocalStorage("Role", payload.role);
    commonFn.setLocalStorage("UserName", payload.userName);
    commonFn.setLocalStorage("Permissions", payload.permissions);
  },
  updateContext(state, payload) {
    state.Context = payload;
    commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
  },
  updateLoading(state, payload) {
    state.Loading = payload;
  },
  updatePermission(state, payload) {
    state.Permission = payload;
  },
  updateFirstLogin(state,payload){
    state.FirstLogin = payload;
  },
  /**
   * clear thông tin phiên đăng nhập
   */
  removeToken(state) {
    state.Token = null;
    state.Context = null;
    state.User = null;
    state.Permission = null;
    state.FirstLogin = true;

    //ghi context vào localstorage
    commonFn.removeLocalStorage("Permission");
    commonFn.removeLocalStorage("TokenTimeout");
    commonFn.removeLocalStorage("Token");
    commonFn.removeLocalStorage("Context");
    commonFn.removeLocalStorage("User");
    commonFn.removeLocalStorage("GettingStarted");
    commonFn.removeLocalStorage("OrganizationUnit");
    commonFn.removeLocalStorage("License");
    commonFn.removeLocalStorage("LicenseError");
  },
  updateLeftMenuCollapse(state, payload) {
    state.LeftMenuCollapse = payload;
  },
  completeGetting(state) {
    let getting = {
      GettingStarted: true,
      SeenGetting: true
    };
    state.GettingStarted = getting;
    commonFn.setLocalStorage("GettingStarted", JSON.stringify(getting));
    window._getting = getting;
    
  }
};
